<template>
  <div class="text-red-600 pb-4">
    <p>{{ message }}</p>

    <ul class="list-inside list-disc">
      <li
        v-for="(error, index) of errors"
        :key="index"
        class="text-sm"
      >
        {{ error.field }} {{ error.message }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    code: {
      type: String,
      required: true
    },

    errors: {
      type: Array,
      required: true
    },

    message: {
      type: String,
      required: true
    }
  }
}
</script>
